import formConfig2026 from '../2026-form/config/form';
import formConfig2025 from '../config/form';

export const loadCorrectFormConfig = (pdfVersion = 'AUG-2025') => {
  return pdfVersion?.includes('2026') ? formConfig2026 : formConfig2025;
};
